import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { CustomerExportReportFormDto } from 'dtos/customerExportReportFormDto'
import { download } from 'utils'

export const getCustomerExportReportForm = () =>
  apiClient
    .get<ApiResponse<CustomerExportReportFormDto>>('/api/reports/customer-export-report/form')
    .then(response => response.data)

export const downloadCustomerExportReport = (companyGuid: string, companyName: string) =>
  apiClient
    .get<Blob>(`/api/reports/customer-export-report?companyGuid=${encodeURIComponent(companyGuid)}`, {
      responseType: 'blob'
    })
    .then(res => {
      download(res.data, getCustomerExportReportFileName(companyName), 'text/csv')
    })

const getCustomerExportReportFileName = (companyName: string) => {
  const date = new Date()
  const timestamp = [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0')
  ].join('')
  const safeCompanyName = companyName.replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '')

  return `${safeCompanyName || 'Customer'}ExportReport_${timestamp}.csv`
}
